import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import { useContainerWidth, LayoutBand, Bleed } from '@fs/zion-ui'
import topicsData from '../../../components/topics'
import NavTabs from '.'
import TopBanner from '../../../components/TopBanner'
import { useUserDetailsContext } from '../../../providers/UserDetailsProvider'
import { usePWAMode } from '../../../hooks'

export default function NavTabsHeader() {
  const atWidth = useContainerWidth()
  const isTablet = atWidth({ sm: true, lg: false, default: false })
  const isMobile = atWidth({ sm: false, default: true })
  const location = useLocation()
  const user = useUser()
  const { points } = useUserDetailsContext()
  const lpRef = useRef()
  const isPWA = usePWAMode()
  const pathsToExcludeBannerNonPWA = [
    '/feed',
    '/activities/familyavatar',
    '/notifications',
    '/more',
    '/stories',
    '/story', // Backward compatibility to support old feed post items
    '/avatar',
    '/groups',
    '/share',
    '/temple',
  ]

  const pathsToExcludeBannerPWA = [
    '/feed',
    '/stories',
    '/notifications',
    '/more',
    '/avatar',
    '/groups',
    '/activities',
    '/share',
    '/temple',
  ]
  const pathsToExclude = isPWA ? pathsToExcludeBannerPWA : pathsToExcludeBannerNonPWA

  const hideTopBanner =
    pathsToExclude.some((path) => location.pathname.startsWith(path) || location.pathname === '/') ||
    location.pathname === '/'

  const getActiveTopicData = () => {
    const locationParts = location.pathname.split('/')
    const page = locationParts && locationParts.length > 0 ? locationParts[locationParts.length - 1] : ''
    return topicsData?.[page]
  }

  const [activeTopicData, setActiveTopicData] = useState(getActiveTopicData())

  useEffect(() => {
    let mounted = true
    // if location path changes other than by NavTabs click (ie: browser back button), update active topic data
    if (location.pathname && !hideTopBanner && mounted) setActiveTopicData(getActiveTopicData())
    return () => {
      mounted = false
    }
  }, [hideTopBanner, location.pathname])

  const bufferFooterBase = () => {
    const footer = document.getElementsByTagName('footer')
    if (footer[0] && (isMobile || isTablet)) {
      footer[0].style.padding = '17px 24px 70px 8px'
    } else if (footer[0]) {
      footer[0].style.padding = '17px 24px 18px 8px'
    }
  }

  const displayTopBanner = () => {
    bufferFooterBase()
    if (hideTopBanner) return null
    const height = isTablet || isMobile ? '280px' : '330px'
    return { position: 'relative', height }
  }

  return (
    <>
      {user?.signedIn && (
        <LayoutBand maxWidth="lg">
          <Bleed all>
            <div style={displayTopBanner()}>
              {!hideTopBanner && (
                <TopBanner points={points} bgref={lpRef} {...activeTopicData} height="100%" {...user} />
              )}
              <NavTabs onClick={setActiveTopicData} />
            </div>
          </Bleed>
        </LayoutBand>
      )}
    </>
  )
}
